module.exports = __webpack_public_path__ + "static/img/imagen-material-2.6fa7b185.png";